export const NATURAL_PERSON = 'N';
export const LEGAL_PERSON = 'J';
export type CustomerType = typeof NATURAL_PERSON | typeof LEGAL_PERSON;

/**
 * Represents the driver for a single unit
 */
export default interface CustomerItem {
  // Backend compatibility property
  id: string;

  /** Customer type */
  type: CustomerType;

  /**
   * Natural person info
   * Obtained by the client details form
   */

  birthday: string;
  firstName: string;
  lastName: string;
  gender: string;

  /** Legal entity info */
  entityName: string;

  /** Customer's general info */
  email: string;
  phoneNumber: string;
  sendEmailCreatorUser: boolean;

  // Used when the driver and the customer must be different
  driverAndCustomerAreDifferent: boolean;
  driverFirstName: string;
  driverLastName: string;
  driverBirthday: string;
  driverGender: string;
  driverIdNumber: string;
  driverIdType: string;

  // Obtained by the driver habits form
  transitZone: string;
  transitTime: string;

  // Obtained by the driver history form
  offensesQty: number;
  collisionsQty: number;
  exonerationQty: number;
  alcoholBreath: number;
}

export function makeEmptyCustomerItem(): CustomerItem {
  return {
    id: '',
    type: NATURAL_PERSON,
    sendEmailCreatorUser: false,
    entityName: '',
    birthday: '',
    firstName: '',
    lastName: '',
    gender: '',
    email: '',
    phoneNumber: '',
    transitZone: '',
    transitTime: '',
    collisionsQty: 0,
    exonerationQty: 0,
    offensesQty: 0,
    alcoholBreath: 0,
    driverAndCustomerAreDifferent: false,
    driverFirstName: '',
    driverLastName: '',
    driverBirthday: '',
    driverGender: '',
    driverIdNumber: '',
    driverIdType: 'N',
  };
}
